import { useState } from 'react';
import { defaultForm } from './const';
import { toast } from 'react-toastify';
import sampleData from './sampleData';
import { forceDownloadUrl, generateUUID } from '../../utils/helper';
import moment from 'moment';
import _ from 'lodash';
import {
  getComprehensive,
  getComprehensiveExport,
} from '../../api/ComprehensiveIncome';
import ComprehensiveIncomeScreen from './Screens/ComprehensiveIncomeScreen';

const ComprehensiveIncome = () => {
  const [filterData, setFilterData] = useState(defaultForm);
  const [tableData, setTableData] = useState({
    data: [],
    loading: false,
    headers: [],
    dateFields: [],
  });

  const loadData = async (params) => {
    try {
      setTableData({ ...tableData, loading: true });

      const res = await getComprehensive(params);

      const { code, result } = res.data.response;

      if (code !== '00000') {
        throw new Error(result);
      }

      //const parseResult = parseData(result, params);
      setTableData({
        ...tableData,
        loading: false,
        data: result.rows,
        headers: result.headers,
        dateFields: result.dateFields,
      });
    } catch (error) {
      setTableData({
        ...tableData,
        loading: false,
        data: [],
        headers: [],
        dateFields: [],
      });
      toast.error(error.message);
    }
  };

  const handleOnFilter = async (data) => {
    loadData(data);
    setFilterData({ ...filterData, ...data });
  };

  const handleOnExport = async (type) => {
    try {
      toast.loading('Exporting data please wait...');

      const res = await getComprehensiveExport({
        ...filterData,
        is_report: type,
      });

      const { code, result } = res.data.response;

      if (code !== '00000') {
        throw new Error(result);
      }

      if (type === 'pdf') {
        window.location.href = forceDownloadUrl(result);
      } else {
        window.location.href = result;
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  return (
    <ComprehensiveIncomeScreen
      onFilter={handleOnFilter}
      onExport={handleOnExport}
      params={filterData}
      tableData={tableData}
    />
  );
};

export default ComprehensiveIncome;
